package com.macrofocus.eflux.ui

import mui.material.Box
import mui.material.Stack
import mui.material.StackDirection
import mui.system.responsive
import mui.system.sx
import org.mkui.component.CPComponent
import react.FC
import react.Props
import web.cssom.Position
import web.cssom.number

external interface TwoColumnsComponentProps : Props {
    var first: CPComponent?
    var second: CPComponent?
}

val TwoColumnsComponent = FC<TwoColumnsComponentProps> { props ->
    Stack {
        direction = responsive(StackDirection.row)

        Box {
            sx {
                position = Position.relative
//                width = 50.pct
//                maxWidth = 50.pct
                flexGrow = number(1.0) // or width = 0.pct and flex = 1.0
            }
            props.first?.nativeComponent()
        }

        Box {
            sx {
                position = Position.relative
//                width = 50.pct
//                maxWidth = 50.pct
                flexGrow = number(1.0) // or width = 0.pct and flex = 1.0
            }
            props.second?.nativeComponent()
        }
    }
}

class CPTwoColumnsComponent constructor(first: CPComponent?, second: CPComponent? = null) : CPComponent {
    override val nativeComponent: FC<*> = FC<Props> { props ->
        TwoColumnsComponent {
            this.first = first
            this.second = second
        }
    }
}